export interface SampleValueColors {
	error: string
	neutral: string
	primary: string
	success: string
}

// Sample colors from our color palette
export const UI_COLORS: SampleValueColors = {
	error: "#FF506F", // $secondary-red
	neutral: "#808285", // $neutrals-dark
	primary: "#30E87A", // $main-green
	success: "#2E75FF", // $secondary-blue
}

export function parseSamplesJson(samples: string | undefined): Record<string, any>[] | null {
	try {
		if (samples) {
			const parsedSamples = JSON.parse(samples)
			if (Array.isArray(parsedSamples) && parsedSamples.length > 0) {
				return parsedSamples
			}
		}
	} catch (e) {
		console.warn("Failed to parse samples JSON:", e)
	}

	return null
}

export interface SampleValueOptions {
	samples?: string
	colors?: SampleValueColors
	now?: () => Date
}

export function createSampleValueResolver(options: SampleValueOptions = {}): (variable: string) => string {
	const {samples, colors = UI_COLORS, now} = options

	return (variable: string): string => {
		// First check if we have samples and use the first sample's value
		try {
			const parsedSamples = parseSamplesJson(samples)
			if (parsedSamples && parsedSamples[0][variable]) {
				return parsedSamples[0][variable]
			}
		} catch (e) {
			console.warn("Failed to parse samples JSON:", e)
		}

		if (variable.includes("firstName")) {
			return "John"
		} else if (variable.includes("lastName")) {
			return "Doe"
		} else if (
			variable.toLowerCase().includes("name") &&
			!variable.toLowerCase().includes("first") &&
			!variable.toLowerCase().includes("last")
		) {
			return "John Doe"
		} else if (variable.includes("email")) {
			return "john.doe@example.com"
		} else if (variable.includes("primaryColor")) {
			return colors.primary
		} else if (variable.includes("successColor")) {
			return colors.success
		} else if (variable.includes("errorColor")) {
			return colors.error
		} else if (variable.includes("company")) {
			return "Relay"
		} else if (variable.includes("brandName")) {
			return "Relay"
		} else if (variable.includes("brandLogoUrl")) {
			return "https://cdn.prod.website-files.com/67ab6f3014e9ebd84ecef25a/67ab6f3014e9ebd84ecef291_Unit%20Logo.svg"
		} else if (variable.includes("date") || variable.toLowerCase().includes("createdat")) {
			return (now?.() ?? new Date()).toLocaleDateString()
		} else if (variable.includes("address")) {
			return "123 Main St, New York, NY"
		} else if (variable.toLowerCase().includes("phone")) {
			return "(555) 123-4567"
		} else if (
			variable.toLowerCase().includes("url") ||
			variable.toLowerCase().includes("website") ||
			variable.toLowerCase().includes("link")
		) {
			return "https://relayfi.com"
		} else if (variable.toLowerCase().includes("support")) {
			return "support@relayfi.com"
		} else if (variable.includes("amount")) {
			return "123.45"
		} else if (variable.includes("merchant")) {
			return "Acme Corp"
		}

		return `Sample ${variable}`
	}
}
